(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  if (!customElements.get('welcome-offer-confirmation')) {
    customElements.define('welcome-offer-confirmation', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.notice = this.querySelector('.welcome-offer-confirmation');
        this.message = this.querySelector('[data-welcome-offer-message]');
        this.addEventListener('click', (event) => {
          if (event.target.closest('[data-welcome-offer-close]')) this.dismiss();
          const link = event.target.closest('[data-welcome-offer-link]');
          if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          if (!this.pending) this.saveOffer(link);
        });
        this.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') this.dismiss();
        });
      }
      disconnectedCallback() { clearTimeout(this.hideTimer); }
      dismiss() {
        clearTimeout(this.hideTimer);
        this.notice.hidden = true;
        this.message.textContent = '';
      }
      async saveOffer(link) {
        this.pending = true;
        link.setAttribute('aria-busy', 'true');
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 10000);
        try {
          const response = await fetch(link.href, {
            credentials: 'same-origin',
            cache: 'no-store',
            signal: controller.signal
          });
          if (!response.ok || new URL(response.url).origin !== window.location.origin) throw new Error('Discount request failed');
          this.notice.hidden = false;
          this.message.textContent = this.message.dataset.message;
          clearTimeout(this.hideTimer);
          this.hideTimer = setTimeout(() => {
            if (!this.notice.contains(document.activeElement)) this.dismiss();
          }, 7000);
        } catch {
          window.location.assign(link.href);
        } finally {
          clearTimeout(timeout);
          this.pending = false;
          link.removeAttribute('aria-busy');
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lisa-category-bubbles"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '.lisa-category-bubbles:not(.lisa-category-bubbles--grid)';
    const initialized = new WeakSet();
    const initialize = () => {
      document.querySelectorAll(selector).forEach(row => {
        if (initialized.has(row)) return;
        initialized.add(row);
        const selected = row.querySelector('.lisa-category-bubbles__link--selected');
        if (!selected) return;
        let interacted = false;
        ['pointerdown', 'wheel', 'keydown'].forEach(type => {
          row.addEventListener(type, () => { interacted = true; }, { once: true, passive: true });
        });
        const reveal = () => {
          if (interacted || !row.isConnected || row.clientWidth === 0 || row.scrollWidth <= row.clientWidth) return;
          const bounds = row.getBoundingClientRect();
          const item = selected.getBoundingClientRect();
          const padding = getComputedStyle(row);
          const left = bounds.left + row.clientLeft + parseFloat(padding.paddingLeft);
          const right = bounds.left + row.clientLeft + row.clientWidth - parseFloat(padding.paddingRight);
          if (item.left >= left - 1 && item.right <= right + 1) return;
          row.scrollBy({
            left: (item.left + item.right - left - right) / 2,
            behavior: 'instant'
          });
        };
        reveal();
        if (document.fonts?.status === 'loading') document.fonts.ready.then(reveal);
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
    else initialize();
    document.addEventListener('shopify:section:load', initialize);
  })();

  (() => {
    if (!('IntersectionObserver' in window)) return;
    const seen = new WeakSet();
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('lisa-winter-revealed');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.5 });
    const observeWinterButtons = () => {
      document.querySelectorAll('.lisa-category-bubbles__link[href*="/collections/winter_gear"]').forEach((button) => {
        if (seen.has(button)) return;
        seen.add(button);
        observer.observe(button);
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observeWinterButtons, { once: true });
    } else {
      observeWinterButtons();
    }
    document.addEventListener('shopify:section:load', observeWinterButtons);
  })();

  (() => {
    const selector = '.lisa-winter-premium:not(.lisa-category-bubbles__link--selected), .lisa-fragrance-discovery';
    const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
    const known = new WeakSet();
    const entered = new WeakSet();
    const previous = new Map();
    const timers = new Map();
    const isFragrance = button => button.classList.contains('lisa-fragrance-discovery');
    const motionClass = button => isFragrance(button) ? 'is-fragrance-playing' : 'is-winter-playing';
    const stop = button => {
      clearTimeout(timers.get(button));
      timers.delete(button);
      button.classList.remove(motionClass(button));
      button.removeAttribute('data-motion-variant');
    };
    const chooseVariant = button => {
      const kind = isFragrance(button) ? 'fragrance' : 'winter';
      const variants = kind === 'fragrance' ? ['classic', 'spritz', 'petals'] : ['classic', 'spin', 'swirl'];
      let last = previous.get(kind);
      try { last = window.sessionStorage.getItem('lisa-category-motion:' + kind) || last; } catch {}
      const choices = variants.filter(variant => variant !== last);
      const next = choices[Math.floor(Math.random() * choices.length)];
      previous.set(kind, next);
      try { window.sessionStorage.setItem('lisa-category-motion:' + kind, next); } catch {}
      return next;
    };
    const play = button => {
      if (preference.matches || document.hidden || timers.has(button)) return;
      button.setAttribute('data-motion-variant', chooseVariant(button));
      button.classList.add(motionClass(button));
      timers.set(button, setTimeout(() => stop(button), 4900));
    };
    const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.intersectionRatio <= .1) {
          entered.delete(entry.target);
          stop(entry.target);
        } else if (entry.intersectionRatio >= .5 && !entered.has(entry.target)) {
          entered.add(entry.target);
          play(entry.target);
        }
      });
    }, { threshold: [0, .1, .5] }) : null;
    const scan = () => {
      document.querySelectorAll(selector).forEach(button => {
        if (known.has(button)) return;
        known.add(button);
        button.addEventListener('animationend', event => {
          if (event.target !== button) return;
          if (event.animationName === 'lisa-winter-edge-glow' || event.animationName === 'lisa-fragrance-edge-glow') stop(button);
        });
        button.addEventListener('pointerenter', event => {
          if (event.pointerType === 'mouse') play(button);
        });
        button.addEventListener('focus', () => {
          if (button.matches(':focus-visible')) play(button);
        });
        observer?.observe(button);
      });
    };
    const stopAll = () => [...timers.keys()].forEach(stop);
    preference.addEventListener('change', () => { if (preference.matches) stopAll(); });
    document.addEventListener('visibilitychange', () => { if (document.hidden) stopAll(); });
    window.addEventListener('pagehide', stopAll);
    document.addEventListener('shopify:section:unload', event => {
      [...timers.keys()].filter(button => event.target.contains(button)).forEach(stop);
      event.target.querySelectorAll(selector).forEach(button => observer?.unobserve(button));
    });
    document.addEventListener('shopify:section:load', scan);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true });
    else scan();
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.layoutInitialized) return;
      this.layoutInitialized = true;
      const section = this.closest('.shopify-section');
      const description = document.querySelector('.product__info-container .product__description');
      if (!section || !description) return;
      const originalPosition = document.createElement('span');
      originalPosition.hidden = true;
      section.after(originalPosition);
      const mobile = window.matchMedia('(max-width: 749px)');
      const placeRecommendations = () => {
        if (mobile.matches) {
          if (section.nextElementSibling !== description) description.before(section);
        } else if (section.nextElementSibling !== originalPosition) {
          originalPosition.before(section);
        }
      };
      mobile.addEventListener('change', placeRecommendations);
      placeRecommendations();
    }

    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              const track = this.querySelector('.lisa-recommendations-track');
              const previous = this.querySelector('button[name="previous"]');
              const next = this.querySelector('button[name="next"]');
              if (track && previous && next) {
                const updateControls = () => {
                  previous.disabled = track.scrollLeft <= 1;
                  next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 1;
                };
                track.addEventListener('scroll', updateControls, { passive: true });
                this.carouselResizeObserver = new ResizeObserver(updateControls);
                this.carouselResizeObserver.observe(track);
                updateControls();
              }
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
